module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('CustomTab', [_c('div', {
    staticClass: "active",
    attrs: {
      "slot": "content",
      "id": "tabSites",
      "title": "Sites"
    },
    slot: "content"
  }, [_c('Sites', {
    attrs: {
      "hideFilter": _vm.hideFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content",
      "id": "tabPrinters",
      "title": "Printers"
    },
    slot: "content"
  }, [_c('Printers', {
    attrs: {
      "hideFilter": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content",
      "id": "tabHistory",
      "title": "History"
    },
    slot: "content"
  }, [_c('PrintHistory')], 1)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f7bff7ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Counter.vue
// module id = 763
// module chunks = 0